/**
 * Sticky Header on Scroll - Simplified
 *
 * Adds .site-header--sticky class when scrolled past 1000px
 * Adds .site-header--sticky-removing for slide-up animation before removing
 * CSS handles all animations and transitions
 */

(function () {
  "use strict";

  const SCROLL_THRESHOLD = 600;
  const STICKY_CLASS = "site-header--sticky";
  const REMOVING_CLASS = "site-header--sticky-removing";
  const ANIMATION_DURATION = 500; // Match CSS animation duration

  let headers = [];
  let isSticky = false;

  /**
   * Update sticky state based on scroll position
   */
  function handleScroll() {
    const scrollY = window.scrollY || window.pageYOffset;
    const shouldBeSticky = scrollY > SCROLL_THRESHOLD;

    if (shouldBeSticky !== isSticky) {
      isSticky = shouldBeSticky;

      headers.forEach((header) => {
        if (isSticky) {
          // Add sticky class - slides down
          header.classList.add(STICKY_CLASS);
        } else {
          // Add removing class for slide-up animation
          header.classList.add(REMOVING_CLASS);

          // After animation completes, remove both classes
          setTimeout(() => {
            header.classList.remove(STICKY_CLASS);
            header.classList.remove(REMOVING_CLASS);
          }, ANIMATION_DURATION);
        }
      });
    }
  }

  /**
   * Initialize
   */
  function init() {
    headers = Array.from(document.querySelectorAll(".site-header"));

    if (headers.length === 0) {
      console.warn("Sticky header: No .site-header elements found");
      return;
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll(); // Check initial state
  }

  // Start when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
